// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// IPoolAddressesProvider https://celoscan.io/address/0x9F7Cf9417D5251C59fE94fB9147feEe1aAd9Cea5
export const POOL_ADDRESSES_PROVIDER = '0x9F7Cf9417D5251C59fE94fB9147feEe1aAd9Cea5';

// IPool https://celoscan.io/address/0x3E59A31363E2ad014dcbc521c4a0d5757d9f3402
export const POOL = '0x3E59A31363E2ad014dcbc521c4a0d5757d9f3402';

// IPoolConfigurator https://celoscan.io/address/0x7567E3434CC1BEf724AB595e6072367Ef4914691
export const POOL_CONFIGURATOR = '0x7567E3434CC1BEf724AB595e6072367Ef4914691';

// IAaveOracle https://celoscan.io/address/0x1e693D088ceFD1E95ba4c4a5F7EeA41a1Ec37e8b
export const ORACLE = '0x1e693D088ceFD1E95ba4c4a5F7EeA41a1Ec37e8b';

// https://celoscan.io/address/0x1dF462e2712496373A347f8ad10802a5E95f053D
export const ACL_ADMIN = '0x1dF462e2712496373A347f8ad10802a5E95f053D';

// IACLManager https://celoscan.io/address/0x7a12dCfd73C1B4cddf294da4cFce75FcaBBa314C
export const ACL_MANAGER = '0x7a12dCfd73C1B4cddf294da4cFce75FcaBBa314C';

// IPoolDataProvider https://celoscan.io/address/0x2e0f8D3B1631296cC7c56538D6Eb6032601E15ED
export const AAVE_PROTOCOL_DATA_PROVIDER = '0x2e0f8D3B1631296cC7c56538D6Eb6032601E15ED';

// https://celoscan.io/address/0x4A1DDf2757666a474CcCEBA735A9f69ed22b75a8
export const POOL_IMPL = '0x4A1DDf2757666a474CcCEBA735A9f69ed22b75a8';

// https://celoscan.io/address/0x6fDdde45f777a4E461B0721a578b169b44579623
export const POOL_CONFIGURATOR_IMPL = '0x6fDdde45f777a4E461B0721a578b169b44579623';

// https://celoscan.io/address/0x4725A0FdbEB14A77964bC1C221eE3a7982263103
export const DEFAULT_INCENTIVES_CONTROLLER = '0x4725A0FdbEB14A77964bC1C221eE3a7982263103';

// https://celoscan.io/address/0x9e04Cb339163b06068397d9b6af2dA78440954e0
export const EMISSION_MANAGER = '0x9e04Cb339163b06068397d9b6af2dA78440954e0';

// ICollector https://celoscan.io/address/0xC959439207dA5341B74aDcdAC59016aa9Be7E9E7
export const COLLECTOR = '0xC959439207dA5341B74aDcdAC59016aa9Be7E9E7';

// https://celoscan.io/address/0x444E85e29F3417E0Df6B697bfDfE5E9A96B550e5
export const DEFAULT_A_TOKEN_IMPL = '0x444E85e29F3417E0Df6B697bfDfE5E9A96B550e5';

// https://celoscan.io/address/0x7e16eeBAC3276515EDD0BC54E7241668eF015E33
export const DEFAULT_VARIABLE_DEBT_TOKEN_IMPL = '0x7e16eeBAC3276515EDD0BC54E7241668eF015E33';

// https://celoscan.io/address/0x8f30ADaA6950b31f675bF8a709Bc23F55aa24735
export const CONFIG_ENGINE = '0x8f30ADaA6950b31f675bF8a709Bc23F55aa24735';

// https://celoscan.io/address/0xB4B6939D0804DCE8d0Ac3e59b2eD5C072829d56b
export const POOL_ADDRESSES_PROVIDER_REGISTRY = '0xB4B6939D0804DCE8d0Ac3e59b2eD5C072829d56b';

// https://celoscan.io/address/0x3A1Ea5fB3098b9767E0e85D63E28A5c0EAa44099
export const UI_INCENTIVE_DATA_PROVIDER = '0x3A1Ea5fB3098b9767E0e85D63E28A5c0EAa44099';

// https://celoscan.io/address/0xe48424542b30b0b8D1Dc09099aceE407f40b4491
export const UI_POOL_DATA_PROVIDER = '0xe48424542b30b0b8D1Dc09099aceE407f40b4491';

// https://celoscan.io/address/0xB91DA65093d54a1a7cb0fe684860F568A5E57123
export const WALLET_BALANCE_PROVIDER = '0xB91DA65093d54a1a7cb0fe684860F568A5E57123';

// https://celoscan.io/address/0x2b33073B94243304bCb4dfFA6b624afA5BAA414D
export const STATA_FACTORY = '0x2b33073B94243304bCb4dfFA6b624afA5BAA414D';

// https://celoscan.io/address/0xdb93e2712a8B36835078f8D28c70fCC95FD6d37c
export const RISK_STEWARD = '0xdb93e2712a8B36835078f8D28c70fCC95FD6d37c';

// https://celoscan.io/address/0x886b90e5d7DA22000f1652740D3EC51566AAbe40
export const DUST_BIN = '0x886b90e5d7DA22000f1652740D3EC51566AAbe40';

export const CHAIN_ID = 42220;
export const ASSETS = {
  USDC: {
    decimals: 6,
    id: 0,
    UNDERLYING: '0xcebA9300f2b948710d2653dD7B07f33A8B32118C',
    A_TOKEN: '0xFF8309b9e99bfd2D4021bc71a362aBD93dBd4785',
    V_TOKEN: '0xDbe517c0FA6467873B684eCcbED77217E471E862',
    INTEREST_RATE_STRATEGY: '0x8B62D241Bf59f40991DCd18531683156d7013355',
    ORACLE: '0xBF704f2FfdB856805cE64D085cD50427823696D7',
    STATA_TOKEN: '0xba3ae0F0A78579a5e8C4188dcde60DcCc0Dd4Fab',
  },
  USDT: {
    decimals: 6,
    id: 1,
    UNDERLYING: '0x48065fbBE25f71C9282ddf5e1cD6D6A887483D5e',
    A_TOKEN: '0xDeE98402A302e4D707fB9bf2bac66fAEEc31e8Df',
    V_TOKEN: '0xE15324a9887999803b931Ac45aa89a94A9750052',
    INTEREST_RATE_STRATEGY: '0x8B62D241Bf59f40991DCd18531683156d7013355',
    ORACLE: '0x6e3d991C965364481796116dE68A8036d1b3Ecd0',
    STATA_TOKEN: '0x5264B1F45616dB619Bb3c8DCeBD86fB33FA0e53F',
  },
  EURm: {
    decimals: 18,
    id: 2,
    UNDERLYING: '0xD8763CBa276a3738E6DE85b4b3bF5FDed6D6cA73',
    A_TOKEN: '0x34c02571094e08E935B8cf8dC10F1Ad6795f1f81',
    V_TOKEN: '0x5C2B7EB5886B3cEc5CCE1019E34493da33291aF5',
    INTEREST_RATE_STRATEGY: '0x8B62D241Bf59f40991DCd18531683156d7013355',
    ORACLE: '0x3D207061Dbe8E2473527611BFecB87Ff12b28dDa',
  },
  USDm: {
    decimals: 18,
    id: 3,
    UNDERLYING: '0x765DE816845861e75A25fCA122bb6898B8B1282a',
    A_TOKEN: '0xBba98352628B0B0c4b40583F593fFCb630935a45',
    V_TOKEN: '0x05Ee3d1fBACbDbA1259946033cd7A42FDFcCcF0d',
    INTEREST_RATE_STRATEGY: '0x8B62D241Bf59f40991DCd18531683156d7013355',
    ORACLE: '0xdCdA3E7E90fe827776b8FDaEa3C5977F123354DA',
  },
  CELO: {
    decimals: 18,
    id: 4,
    UNDERLYING: '0x471EcE3750Da237f93B8E339c536989b8978a438',
    A_TOKEN: '0xC3e77dC389537Db1EEc7C33B95Cf3beECA71A209',
    V_TOKEN: '0xaEa37B42955De2Ba2E4AF6581E46349bCD3Ea2d6',
    INTEREST_RATE_STRATEGY: '0x8B62D241Bf59f40991DCd18531683156d7013355',
    ORACLE: '0x0568fD19986748cEfF3301e55c0eb1E729E0Ab7e',
    STATA_TOKEN: '0xfdf1911C72760Cea0d06d368d44b38c61aCF1b50',
  },
  WETH: {
    decimals: 18,
    id: 5,
    UNDERLYING: '0xD221812de1BD094f35587EE8E174B07B6167D9Af',
    A_TOKEN: '0xf385280F36e009C157697D25E0B802EfaBfd789c',
    V_TOKEN: '0x6508cff7c5FbA053Af00a4E894500e6fA00274B7',
    INTEREST_RATE_STRATEGY: '0x8B62D241Bf59f40991DCd18531683156d7013355',
    ORACLE: '0x1FcD30A73D67639c1cD89ff5746E7585731c083B',
  },
} as const;
export const E_MODES = {} as const;
export const EXTERNAL_LIBRARIES = {
  FLASHLOAN_LOGIC: '0xE66AdcF153d0bD67a74e5d23e23F90b4011024EC',
  BORROW_LOGIC: '0x1Fb8f7C906cddD28B42ae6Eb76abC04A91188635',
  LIQUIDATION_LOGIC: '0x8dc095F287dBEBD9e15f75BB3DfBF18389BB8104',
  POOL_LOGIC: '0x25Ed699a052B820d772765E26Ed4dD9f0A26F3E5',
  SUPPLY_LOGIC: '0x33654b16A4De97bCE05d7dD06803Bf1066f3123C',
} as const;
